import React from "react";
import styles from "./LoginAdmin.module.css";
import { useNavigate } from "react-router-dom";

const LoginAdmin = () => {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Add actual login logic here (e.g. API call)

    navigate("/bookingManagement"); // redirect after successful login
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.brand}>AURELIA</h1>
        <h2 className={styles.title}>Login</h2>
        <form className={styles.forms} onSubmit={handleSubmit}>
          <input type="email" placeholder="Email" required />
          <input
            type="password"
            className={styles.password}
            placeholder="Password"
            required
          />
          <button type="submit">
            CONTINUE
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginAdmin;
